import React, { useEffect } from "react";

import AutenticaçãoRoutes from "./auth.routes";
import AppRoutes from "../routes/app.routes";
import { useAutenticação } from "../core/contexts/auth";
import { mascararEmail } from "../core/services/clarity";

const Routes: React.FC = () => {


  // O app vai voltar para as rotas de autenticação
  const { signed, getUsuarioCookie } = useAutenticação();


  useEffect(() => {
    if (signed || getUsuarioCookie()) {

      const emailMascarado = mascararEmail(getUsuarioCookie()?.des_email || "");
      // Setar o email uma vez no início da sessão
      window.clarity?.('set', 'usuario_email', emailMascarado);
      // Enviar evento a cada pageview
      window.clarity?.('event', `pagina_visitada_${location.pathname}`);
    }

  }, [location.pathname]); // use isso junto com useLocation() do React Router


  return signed || getUsuarioCookie() ? <AppRoutes /> : <AutenticaçãoRoutes />;

};

export default Routes;
